export default {"src":"/_next/static/image/public/images/ic_thank_you.65bae9eaca717458ea9b026496a667f7.svg","height":147,"width":134};